/* eslint-disable no-console */
//import '@babel/polyfill'
//import "@babel/plugin-proposal-object-rest-spread"
// import 'core-js';
// import 'regenerator-runtime/runtime';

import Vue from 'vue'
import App from './App.vue'

// 3rd party
import axios from 'axios'
import VueScrollmagic from 'vue-scrollmagic'
import VueWindowSize from 'vue-window-size';
import VueLazyload from 'vue-lazyload'

import rangy from 'rangy-updated';
import 'rangy-updated/lib/rangy-highlighter.js'
import 'rangy-updated/lib/rangy-classapplier.js'

import VueHtml2Canvas from 'vue-html2canvas'

// css
import 'flickity/dist/flickity.css'
import './assets/fonts/lekton.css'
import './assets/fonts/univers.css'
import './assets/fonts/univers-condensed.css'
import './assets/fonts/utopia.css'
import './assets/fonts/utopia-bold.css'
import './assets/styles/global.css'

// local
import { store } from './store/store.js'
import { i18n, gatherTranslations } from './services/i18n/i18n.js'
import { router } from './router/router.js'


axios.defaults.baseURL = '/'
Vue.config.productionTip = false;

Object.defineProperty(Vue.prototype, '$rangy', { value: rangy });

Vue.use(VueLazyload, {
  lazyComponent: true
});
Vue.use(VueHtml2Canvas);
Vue.use(VueWindowSize);
Vue.use(VueScrollmagic, {
  globalSceneOptions: {},
  loglevel: 2,
  refreshInterval: 100
})

gatherTranslations().then(() => {
  new Vue({
    store,
    i18n,
    router,
    render: h => h(App),
  }).$mount('#app')
})